export default __webpack_public_path__ + "static/media/burger.356e0966.svg";